import { Chip } from '@mui/material';
import type { StyleObj } from '../../@types';

type BetBuilderBadgeProps = {
  enabled?: boolean;
};

const styles: StyleObj = {
  badge: {
    color: 'primary.contrastText',
    fontWeight: 700,
  },
};

const BetBuilderBadge = ({ enabled }: BetBuilderBadgeProps) => {
  if (!enabled) return null;

  return <Chip label='BB' color='primary' size='small' sx={styles.badge} />;
};

export default BetBuilderBadge;
